import React, { useEffect, useState } from 'react';
import AllResponses from './components/AllResponses';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import Tab from '@material-ui/core/Tab';
import RecommendationsPerClient from './components/RecommendationsPerClient';
import PotentialRisk from './components/PotentialRisk';
import ProspectConversion from './components/ProspectConversion';
import { Box, FormControlLabel } from '@material-ui/core';
import FiltersSection from './components/FiltersSection';
import { FormSectionTitle } from '../../Components/Typography/Headlines';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { SERVICE_TYPE_FILTERS } from '../../constants/elevation';
import { useDataProvider, useNotify } from 'react-admin';
import Spinner from '../../Components/Spinner';

const useStyles = makeStyles(theme => ({
    title: {
        fontSize: '35px',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        },
        marginBottom: theme.spacing(3),
    },
    tab: {
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.spacing(2),
        '&.Mui-selected': {
            color: theme.palette.primary.main,
        },
    },
    panel: {
        padding: `${theme.spacing(3)}px 0`,
    },
    switchLabel: {
        fontSize: theme.spacing(2),
    },
    tabsAndSwitchContainer: {
        padding: `${theme.spacing(3)}px 0 0 0`,
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'flex-start !important',
            '& .MuiFormControlLabel-root': {
                padding: `${theme.spacing(3)}px 0 0 0`
            },
            '& .MuiTypography-root': {
                margin: 0,
            }
        },
    }
}))

const ElevationDashboard = () => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const notify = useNotify()

    const [primaryServiceTypeFetched, setPrimaryServiceTypeFetched] = useState(false)
    const [tabValue, setTabValue] = React.useState('0')
    const [showDialog, setShowDialog] = useState(false)

    const toDate = new Date()
    const fromDate = new Date()
    fromDate.setFullYear(fromDate.getFullYear() - 1)
    const [range, setRange] = useState(
        {
            from: fromDate,
            to: toDate
        }
    )
    const [serviceType, setServiceType] = useState(null)
    const [switchChecked, setSwitchChecked] = useState(false)

    const handleDialogCloseClick = () => setShowDialog(false)
    const handleDialogClearClick = () => {
        setRange({ from: fromDate, to: toDate })
        setShowDialog(false)
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const handleSwitch = () => setSwitchChecked(!switchChecked)
    const handleSwitchKeyDown = (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        handleSwitch()
    }

    const handleServiceTypeChange = (e) => {
        setServiceType(SERVICE_TYPE_FILTERS.find(item => item.type === e.target.value).type)
    }

    const fetchPrimaryServiceType = () => {
        dataProvider('GET_ONE', 'elevation/primary-service-type')
            .then(res => {
                if (res.data.service_type_id) {
                    setServiceType(res.data.service_type_id)
                } else {
                    setServiceType(SERVICE_TYPE_FILTERS.find(item => item.type === 1).type)
                }
                setPrimaryServiceTypeFetched(true)
            })
            .catch((e) => {
                notify(e.message, 'warning')
            })
    }

    useEffect(()=> {
        fetchPrimaryServiceType()
    },[])

    return (
        <Card>
            <CardContent>
                <FormSectionTitle title="Elevation Dashboard" className={classes.title} color={'textPrimary'} />
                <Box>
                    <FiltersSection
                        handleCloseClick={handleDialogCloseClick}
                        handleClearClick={handleDialogClearClick}
                        showDialog={showDialog}
                        range={range}
                        serviceType={serviceType}
                        setRange={setRange}
                        setShowDialog={setShowDialog}
                        handleServiceTypeChange={handleServiceTypeChange}
                        primaryServiceTypeFetched={primaryServiceTypeFetched}
                    />
                </Box>
                <TabContext value={tabValue}>
                    <div className={classes.tabsAndSwitchContainer}>
                        <TabList onChange={handleTabChange} scrollButtons="auto" variant="scrollable">
                            <Tab label="All responses" value="0" className={classes.tab} />
                            <Tab label="Recommendations per client" value="1" className={classes.tab} />
                            <Tab label="Potential risk" value="2" className={classes.tab} />
                            <Tab label="Prospect conversion" value="3" className={classes.tab} />
                        </TabList>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={switchChecked}
                                    onClick={handleSwitch}
                                    onKeyDown={handleSwitchKeyDown}
                                    name="legend-toggle"
                                />
                            }
                            label={<Typography className={classes.switchLabel}>Show answer details</Typography>}
                        />
                    </div>
                    {!primaryServiceTypeFetched && <Spinner />}
                    {primaryServiceTypeFetched && serviceType &&
                        <>
                            <TabPanel value="0" className={classes.panel}>
                                <AllResponses showLegend={switchChecked} range={range} serviceType={serviceType}/>
                            </TabPanel>
                            <TabPanel value="1" className={classes.panel}>
                                <RecommendationsPerClient showLegend={switchChecked} range={range} serviceType={serviceType}/>
                            </TabPanel>
                            <TabPanel value="2" className={classes.panel}>
                                <PotentialRisk showLegend={switchChecked} range={range} serviceType={serviceType}/>
                            </TabPanel>
                            <TabPanel value="3" className={classes.panel}>
                                <ProspectConversion showLegend={switchChecked} range={range} serviceType={serviceType}/>
                            </TabPanel>
                        </>
                    }
                </TabContext>

            </CardContent>
        </Card>
    )
}

export default ElevationDashboard